export default "__VITE_ASSET__Cqh_7RwT__"